import { Flex } from '@chakra-ui/react';
import GitHubCalendar from 'react-github-calendar';
import Heading from './Heading';


export default function Calendar(){
    return (
        <Flex padding={"5"} margin={"auto"} alignItems={"center"} gap={"20"} justifyContent={"center"} marginTop={"50px"} direction={"column"}>
            <Heading
        text={`GitHub Calendar`}
        size="lg"
        />
       < GitHubCalendar username="Abhishree-codes" hideColorLegend={true} style={{borderRadius:"10px"}}/>
        </Flex>
    )
}